// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\NotificationSettingCapabilitiesResponse

export type NotificationSettingCapabilitiesApiResponse = {
	app: boolean;
	push: boolean;
	email: boolean;
};

export type NotificationSettingCapabilities = {
	app: boolean;
	push: boolean;
	email: boolean;
};

export function hydrateNotificationSettingCapabilities(data: NotificationSettingCapabilitiesApiResponse): NotificationSettingCapabilities {
	return { ...data };
}